import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { ProcessoGrupo } from '../models/processo-grupo.model';
import { Observable } from 'rxjs';

@Injectable()
export class ProcessoGrupoService extends BaseService<ProcessoGrupo> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getInfoProcesso(id: number): Observable<any>{
    return this.http.get<any>(this.baseUrl + '/info-processo/' + id , { headers: this.headers });
  }

  public updateOrdem(obj: any): Observable<any> {
    return this.http.put<any>(this.baseUrl +'/atualiza-ordem' , obj, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/pre-projeto/processo-grupo';
  }
}
